import { Theme } from './components/Theme'

export const ThemeGrid = ({themes, ...props}) => {
    return(
        <div className={`c-themeGrid__container ${props.bottomSpacing ? props.bottomSpacing : ""}`} >
            {themes.map((theme,index) => (
                <Theme
                    key={index}
                    title={theme.title}
                    image={theme.icon}
                    url={theme.url}
                    alt={theme.alt}
                />
            ))}
        </div>
    )
}